import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { ConsumerSidebarComponent } from '../sidebar/consumer-sidebar.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { MyRequestSharedComponent } from '../../shared/components/my-request-shared/my-request-shared.component';

@Component({
  selector: 'app-my-request',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    ConsumerSidebarComponent,
    PageHeaderComponent,
    MyRequestSharedComponent,
  ],
  templateUrl: './my-request.component.html',
  styleUrl: './my-request.component.scss',
})
export class MyRequestComponent {}

